import { TCreateInstitutionForm } from './schema';
import { EMPTY_INSTITUTION_CONTRACT } from '@pages/AdminPanel/schemas';
import { ELanguage } from '@/types';

export const defaultValues: TCreateInstitutionForm = {
  name: '',
  language: ELanguage.EN,
  address1: '',
  address2: '',
  city: '',
  state: '',
  country: '',
  zip: '',
  pocSettings: {
    name: '',
    title: '',
    email: '',
    phone: { country: 'US', number: '' },
    address1: '',
    address2: '',
    state: '',
    country: '',
    zip: '',
  },
  provisioning: {
    contracts: [EMPTY_INSTITUTION_CONTRACT],
  },
};
